// extracted by css-extract-rspack-plugin
export default {"count":"count-aTgNF9"};